import { gql } from '@apollo/client';
import { AgentActivityLogReview, AgentActivityLogReviewStatus } from '@trnsact/trnsact-shared-types';

export const AGENT_ACTIVITY_LOG_REVIEW_CONFIRM = gql`
  mutation ConfirmAgentActivityLogReview($input: ConfirmAgentActivityLogReviewInput!) {
    agentActivityLogReview {
      confirm(input: $input) {
        success
        error
        entity {
          agentActivityLogId
          status
        }
      }
    }
  }
`;

export const AGENT_ACTIVITY_LOG_REVIEW_REJECT = gql`
  mutation RejectAgentActivityLogReview($input: RejectAgentActivityLogReviewInput!) {
    agentActivityLogReview {
      reject(input: $input) {
        success
        error
        entity {
          agentActivityLogId
          status
        }
      }
    }
  }
`;

export const AGENT_ACTIVITY_LOG_REVIEW_DISMISS = gql`
  mutation DismissAgentActivityLogReview($input: DismissAgentActivityLogReviewInput!) {
    agentActivityLogReview {
      dismiss(input: $input) {
        success
        error
        entity {
          agentActivityLogId
          status
        }
      }
    }
  }
`;

export { AgentActivityLogReviewStatus };

interface AgentActivityLogReviewActionResult {
  success: boolean;
  error: string | null;
  entity: Pick<AgentActivityLogReview, 'agentActivityLogId' | 'status'> | null;
}

export interface ConfirmAgentActivityLogReviewResponse {
  agentActivityLogReview: { confirm: AgentActivityLogReviewActionResult };
}

export interface RejectAgentActivityLogReviewResponse {
  agentActivityLogReview: { reject: AgentActivityLogReviewActionResult };
}

export interface DismissAgentActivityLogReviewResponse {
  agentActivityLogReview: { dismiss: AgentActivityLogReviewActionResult };
}
